import React from "react";
import styled from "styled-components";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import SelectGroup from "../SelectGroup";
import { RESTRICTION_TYPE } from "../../../Common/constants";

const messages = defineMessages({
  minStay: {
    id: "app.contractableConditions.minStay",
    description: "Min. Stay (days)",
    defaultMessage: "Min. Stay (days)",
  },
  maxStay: {
    id: "app.contractableConditions.maxStay",
    description: "Max. Stay (days)",
    defaultMessage: "Max. Stay (days)",
  },
  minNotice: {
    id: "app.contractableConditions.minNotice",
    description: "Minimum advance (days)",
    defaultMessage: "Minimum advance (days)",
  },
  maxNotice: {
    id: "app.contractableConditions.maxNotice",
    description: "Maximum advance (days)",
    defaultMessage: "Maximum advance (days)",
  },
  noLimit: {
    id: "app.contractableConditions.noLimit",
    description: "Unlimited",
    defaultMessage: "Unlimited",
  },
  constant: {
    id: "app.contractableConditions.constant",
    description: "Constant",
    defaultMessage: "Constant",
  },
  moreThanZero: {
    id: "app.contractableConditions.moreThanZero",
    description: "Must be more than 0",
    defaultMessage: "Must be more than 0",
  },
  pressence: {
    id: "app.input.pressence",
    description: "Can't be blank",
    defaultMessage: "Can't be blank",
  },
  mustBeNumber: {
    id: "app.input.mustBeNumber",
    description: "It must be a number",
    defaultMessage: "It must be a number",
  },
});

const restrictionTypes = [
  RESTRICTION_TYPE.MIN_STAY,
  RESTRICTION_TYPE.MAX_STAY,
  RESTRICTION_TYPE.MIN_NOTICE,
  RESTRICTION_TYPE.MAX_NOTICE,
];
const restrictionTranslations = {
  MIN_STAY: <FormattedMessage {...messages.minStay} />,
  MAX_STAY: <FormattedMessage {...messages.maxStay} />,
  MIN_NOTICE: <FormattedMessage {...messages.minNotice} />,
  MAX_NOTICE: <FormattedMessage {...messages.maxNotice} />,
};

const SelectGroupContainer = styled.div`
  margin-bottom: 20px;
  > fieldset {
    padding-bottom: 0;

    fieldset {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
`;

function ContractableConditions({ formValues, onChange, intl, disabled }) {
  return (
    <div>
      {restrictionTypes.map(restriction => {
        const value = formValues[`${restriction}_duration`];
        const errors = [];

        if (!value && value !== 0) {
          errors.push(intl.formatMessage(messages.pressence));
        } else if (isNaN(value)) {
          errors.push(intl.formatMessage(messages.mustBeNumber));
        } else if (value <= 0) {
          errors.push(intl.formatMessage(messages.moreThanZero));
        }

        return (
          <SelectGroupContainer key={restriction}>
            <label>{restrictionTranslations[restriction]}</label>
            <SelectGroup
              value={formValues[restriction]}
              field={{
                disabled:disabled,
                fieldName: restriction,
                displayName: restrictionTranslations[restriction],
                optionDisplay: {
                  NO_LIMIT: {
                    label: intl.formatMessage(messages.noLimit),
                  },
                  CONSTANT: {
                    label: intl.formatMessage(messages.constant),
                  },
                },
              }}
              additionalFields={[
                {
                  value,
                  field: {
                    fieldName: `${restriction}_duration`,
                  },
                  isVisible: formValues[restriction] === "CONSTANT",
                  onChange,
                  errors,
                },
              ]}
              onChange={onChange}
            />
          </SelectGroupContainer>
        );
      })}
    </div>
  );
}

export default injectIntl(ContractableConditions);
